import { apiClient } from './client';
import type { DashboardMetrics, RevenueMetrics, UserMetrics, ProcessingMetrics, AnalyticsTimeSeriesResponse } from '../types/analytics';

export const analyticsApi = {
  getDashboard: () =>
    apiClient.get<DashboardMetrics>('/analytics/dashboard').then((r) => ({
      ...r.data,
      mrr_usd: Number(r.data.mrr_usd),
      arr_usd: Number(r.data.arr_usd),
    })),

  getRevenue: (days = 30) =>
    apiClient.get<RevenueMetrics[]>('/analytics/revenue', { params: { days } }).then((r) =>
      r.data.map((m) => ({ ...m, mrr_usd: Number(m.mrr_usd), arr_usd: Number(m.arr_usd) }))
    ),

  getUsers: (days = 30) =>
    apiClient.get<UserMetrics[]>('/analytics/users', { params: { days } }).then((r) => r.data),

  getProcessing: (days = 30) =>
    apiClient.get<ProcessingMetrics[]>('/analytics/processing', { params: { days } }).then((r) => r.data),

  getTimeseries: (metric: string, days = 30) =>
    apiClient.get<AnalyticsTimeSeriesResponse>(`/analytics/timeseries/${metric}`, { params: { days } }).then((r) => r.data),
};
